import { computed, inject, Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { AsyncApiService } from '@spike/core';
import { ConfirmationDialogService } from '../../shared/services/confirmation-dialog.service';
import { ModelApiEnum } from 'src/app/config/entity-api.enum';
import { EntityModel } from '../models/entity-model.model';

@Injectable({ providedIn: 'root' })
export class ModelStoreService {
    private readonly confirmationDialogService = inject(ConfirmationDialogService);
    private readonly asyncApiService = inject(AsyncApiService);
    private readonly modelMap :Map<ModelApiEnum, WritableSignal<EntityModel[]>> = new Map<ModelApiEnum, WritableSignal<EntityModel[]>>([]);


    public async save(apiEnum: ModelApiEnum, entity: EntityModel){
        await this.asyncApiService.save(apiEnum, entity, entity.modelId?? undefined);
        await this.reload(apiEnum);
    }

    public async deleteById(apiEnum: ModelApiEnum, id: number) {
        this.confirmationDialogService.show('Sei sicuro di voler eliminare questo modello?', async () => {
            await this.deleteByIdConfirmed(apiEnum, id);
        });
    }
    public async deleteByIdConfirmed(apiEnum: ModelApiEnum, id: number) {
        await this.asyncApiService.deleteById(apiEnum, id);
        await this.reload(apiEnum);
    }

   public get(apiEnum: ModelApiEnum): Signal<EntityModel[]> {
        if (!this.modelMap.has(apiEnum)) {
            this.modelMap.set(apiEnum, signal<EntityModel[]>([]));
            this.reload(apiEnum);
        }
        return this.modelMap.get(apiEnum)!.asReadonly();
    }

    private async reload(apiEnum: ModelApiEnum){
        const res = await this.asyncApiService.selectAll<EntityModel>(apiEnum);
        if (!this.modelMap.has(apiEnum)) {
            this.modelMap.set(apiEnum, signal(res));
        }else{
            this.modelMap.get(apiEnum)!.set(res);

        }
    }
    
    public getReactiveList(apiEnumSignal: Signal<ModelApiEnum>): Signal<EntityModel[]> {
        return computed(() => {
            const api = apiEnumSignal();
            const listSignal = this.get(api);
            return listSignal();
        });
    }

    public findStatic(apiEnum: ModelApiEnum, id: number | undefined): EntityModel | undefined {
        if (!id) return undefined;        
        const currentList = this.get(apiEnum)();
        return currentList.find(x => x.modelId === id);
    }
        
}